




















































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DokterAutoComplete from "@/components/pemeriksaan/assesmen/DokterAutoComplete.vue";
import CeklistAlteplasePage from "@/components/pemeriksaan/assesmen/CeklistAlteplasePage.vue";
import { storeScreeningTrombolisis } from "@/store/modules/ScreeningTrombolisisStore";
import ScreeningTrombolisisSvc from "@/services/ScreeningTrombolisis";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { alasanTtdMengunciHapus } from "@/utils/hapusSetelahTtd";

@Component({
  components: {
    CardModalTtd,
    DokterAutoComplete,
    CeklistAlteplasePage
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class ScreeningTrombolisisPage extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  isEditing = false;
  editingId: number | null = null;
  modalTtd = false;
  saving = false;
  formValid = false;
  timeInterval: any = null;
  nowTime: Date = new Date();

  form: any = this.getEmptyForm();

  indikasiItems = [
    { key: "a1_informed_consent", label: "Pasien atau keluarga pasien setuju (Informed Consent)" },
    { key: "a2_waktu_kurang_4_5_jam", label: "Waktu timbul gejala hingga dimulainya trombolisis intravena < 4,5 jam" },
    { key: "a3_stroke_iskemik_nihss", label: "Diagnosis klinis stroke iskemik, NIHSS > 2 atau \u2264 24" },
    { key: "a4_usia_diatas_18", label: "Usia > 18 tahun" }
  ];

  kontraIndikasiSections = [
    {
      title: "B.1 — Riwayat Perjalanan Penyakit",
      items: [
        { key: "b1_1_bedah_saraf_3bulan", label: "Operasi bedah saraf, cedera kepala berat, atau riwayat stroke berat dalam 3 bulan terakhir" },
        { key: "b1_2_perdarahan_intrakranial", label: "Riwayat perdarahan intrakranial" },
        { key: "b1_3_avm_aneurisma", label: "Diagnosis AVM / Aneurisma" },
        { key: "b1_4_perdarahan_gi_urin_21hari", label: "Perdarahan gastrointestinal atau traktus urinarius dalam 21 hari terakhir" },
        { key: "b1_5_operasi_besar_14hari", label: "Operasi besar, trauma berat, arterial puncture, atau LP dalam 14 hari terakhir" }
      ]
    },
    {
      title: "B.2 — Klinis",
      items: [
        { key: "b2_1_perbaikan_cepat", label: "Perbaikan yang cepat atau perburukan tanda-tanda neurologis / gejala minor" },
        { key: "b2_2_td_tinggi", label: "Tekanan darah sistolik > 185 mmHg atau diastolik > 110 mmHg" },
        { key: "b2_3_kejang_onset", label: "Terdapat kejang pada saat timbul gejala (onset)" },
        { key: "b2_4_perdarahan_subarakhnoid", label: "Gejala klinis sangat mencurigai perdarahan subarakhnoid" },
        { key: "b2_5_infark_miokard_30hari", label: "Riwayat infark miokard dalam 30 hari terakhir" }
      ]
    },
    {
      title: "B.3 — Hasil Laboratorium",
      items: [
        { key: "b3_1_antikoagulan_ptt_inr", label: "Pasien mengonsumsi antikoagulan dan nilai PTT > 15 detik atau INR > 1,7" },
        { key: "b3_2_heparin_aptt", label: "Pasien mendapat terapi Heparin IV/subkutan dalam 48 jam, atau peningkatan APTT" },
        { key: "b3_3_trombosit_rendah", label: "Hitung trombosit < 100 \u00d7 10\u2079/L" },
        { key: "b3_4_glukosa_abnormal", label: "Glukosa darah < 50 mg/dL atau > 400 mg/dL" },
        { key: "b3_5_kehamilan_positif", label: "Pasien perempuan dalam masa produktif dengan hasil tes kehamilan positif" }
      ]
    },
    {
      title: "B.4 — Kontra Indikasi pada CT Scan",
      items: [
        { key: "b4_1_lesi_densitas_tinggi", label: "CT menunjukkan lesi densitas tinggi dan perdarahan intrakranial" },
        { key: "b4_2_efek_massa_midline", label: "CT menunjukkan efek massa disertai pendorongan garis tengah (midline shift)" },
        { key: "b4_3_hipodensitas_33persen", label: "CT menunjukkan hipodensitas parenkim dan/atau hilangnya sulkus serebri > 33% hemisfer" }
      ]
    }
  ];

  mounted() {
    storeScreeningTrombolisis.getByRegister(this.register);
    // Realtime time update every minute
    this.timeInterval = setInterval(() => {
      this.nowTime = new Date();
    }, 60000);
  }

  beforeDestroy() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  }

  get stateData() {
    return storeScreeningTrombolisis.data;
  }

  get stateLoading() {
    return storeScreeningTrombolisis.loading;
  }

  get stateuser() {
    return userModule.user;
  }

  get canEdit() {
    if (this.readOnly) return false;
    return this.stateData && !this.stateData.signed_dokter;
  }

  get canDelete() {
    if (this.readOnly) return false;
    if (!this.stateData) return false;
    return !alasanTtdMengunciHapus(
      this.stateData.creator_user_id,
      [{ ditandatangani: this.stateData.signed_dokter, penandaTanganId: this.stateData.dokter_user_id }],
      this.stateuser && this.stateuser.id
    );
  }

  get canSignDokter() {
    if (this.readOnly) return false;
    return this.stateData && !this.stateData.signed_dokter && this.stateData.dokter_user_id == this.stateuser.id;
  }

  // ========== VIEW computed ==========
  get viewSemuaIndikasiOk() {
    if (!this.stateData) return false;
    return this.stateData.a1_informed_consent
      && this.stateData.a2_waktu_kurang_4_5_jam
      && this.stateData.a3_stroke_iskemik_nihss
      && this.stateData.a4_usia_diatas_18;
  }

  get viewTidakAdaKontra() {
    if (!this.stateData) return false;
    return this.allKontraKeys.every(k => !this.stateData[k]);
  }

  get viewWindowAlertType() {
    if (!this.stateData) return "info";
    if (this.stateData.window_waktu === "kurang_4_5_jam") return "success";
    if (this.stateData.window_waktu === "4_5_sampai_6_jam") return "warning";
    return "error";
  }

  get viewWindowText() {
    if (!this.stateData || !this.stateData.waktu_onset_gejala) return "";
    const onset = new Date(this.stateData.waktu_onset_gejala);
    const diff = this.nowTime.getTime() - onset.getTime();
    const jam = Math.floor(diff / 3600000);
    const menit = Math.floor((diff % 3600000) / 60000);
    return `${jam} jam ${menit} menit dari onset`;
  }

  // ========== FORM computed ==========
  get allKontraKeys() {
    const keys: string[] = [];
    for (const s of this.kontraIndikasiSections) {
      for (const i of s.items) {
        keys.push(i.key);
      }
    }
    return keys;
  }

  get semuaIndikasiOk() {
    return this.form.a1_informed_consent === true
      && this.form.a2_waktu_kurang_4_5_jam === true
      && this.form.a3_stroke_iskemik_nihss === true
      && this.form.a4_usia_diatas_18 === true;
  }

  get anyIndikasiAnswered() {
    return this.indikasiItems.some(i => this.form[i.key] !== null);
  }

  get tidakAdaKontra() {
    return this.allKontraKeys.every(k => this.form[k] === false);
  }

  get anyKontraAnswered() {
    return this.allKontraKeys.some(k => this.form[k] !== null);
  }

  get kontraIndikasiDitemukan() {
    const found: string[] = [];
    for (const s of this.kontraIndikasiSections) {
      for (const i of s.items) {
        if (this.form[i.key] === true) {
          found.push(i.label.substring(0, 40) + "...");
        }
      }
    }
    return found;
  }

  get computedKeputusan() {
    if (this.semuaIndikasiOk && this.tidakAdaKontra) return "memenuhi";
    return "tidak_memenuhi";
  }

  get windowDiffMs() {
    if (!this.form.waktu_onset_gejala) return 0;
    const onset = new Date(this.form.waktu_onset_gejala);
    return this.nowTime.getTime() - onset.getTime();
  }

  get windowDisplay() {
    if (!this.form.waktu_onset_gejala) return "-";
    const diff = this.windowDiffMs;
    const jam = Math.floor(diff / 3600000);
    const menit = Math.floor((diff % 3600000) / 60000);
    return `${jam} jam ${menit} menit dari onset`;
  }

  get timeAlertType() {
    const hours = this.windowDiffMs / 3600000;
    if (hours < 3) return "success";
    if (hours < 4) return "warning";
    return "error";
  }

  // ========== METHODS ==========
  getEmptyForm() {
    const form: any = {
      waktu_kehadiran: this.toLocalDatetime(new Date()),
      waktu_onset_gejala: null,
      window_waktu: null,
      a1_informed_consent: null,
      a2_waktu_kurang_4_5_jam: null,
      a3_stroke_iskemik_nihss: null,
      a4_usia_diatas_18: null,
      nihss_score: null,
      b1_1_bedah_saraf_3bulan: false,
      b1_2_perdarahan_intrakranial: false,
      b1_3_avm_aneurisma: false,
      b1_4_perdarahan_gi_urin_21hari: false,
      b1_5_operasi_besar_14hari: false,
      b2_1_perbaikan_cepat: false,
      b2_2_td_tinggi: false,
      b2_3_kejang_onset: false,
      b2_4_perdarahan_subarakhnoid: false,
      b2_5_infark_miokard_30hari: false,
      b3_1_antikoagulan_ptt_inr: false,
      b3_2_heparin_aptt: false,
      b3_3_trombosit_rendah: false,
      b3_4_glukosa_abnormal: false,
      b3_5_kehamilan_positif: false,
      b4_1_lesi_densitas_tinggi: false,
      b4_2_efek_massa_midline: false,
      b4_3_hipodensitas_33persen: false,
      keputusan: null,
      dokter_user_id: null,
      dokter_obj: null
    };
    return form;
  }

  toLocalDatetime(d: Date) {
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  formatDateTime(dt) {
    if (!dt) return "-";
    try {
      const d = new Date(dt);
      const pad = (n: number) => String(n).padStart(2, "0");
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    } catch {
      return dt;
    }
  }

  windowLabel(val) {
    if (val === "kurang_4_5_jam") return "< 4,5 Jam";
    if (val === "4_5_sampai_6_jam") return "4,5 - 6 Jam";
    if (val === "lebih_6_jam") return "> 6 Jam";
    return val;
  }

  onOnsetChange() {
    // Auto-calc window_waktu based on onset vs now
    if (this.form.waktu_onset_gejala) {
      const hours = this.windowDiffMs / 3600000;
      if (hours < 4.5) {
        this.form.window_waktu = "kurang_4_5_jam";
      } else if (hours < 6) {
        this.form.window_waktu = "4_5_sampai_6_jam";
        // Auto-set a2 to false — window exceeded
        this.form.a2_waktu_kurang_4_5_jam = false;
      } else {
        this.form.window_waktu = "lebih_6_jam";
        this.form.a2_waktu_kurang_4_5_jam = false;
      }
    }
  }

  setDokter(dokter) {
    if (dokter) {
      this.form.dokter_user_id = dokter.id;
      this.form.dokter_obj = dokter;
    }
  }

  startCreate() {
    this.form = this.getEmptyForm();
    // Auto-fill dokter dari user yang sedang login
    if (this.stateuser && this.stateuser.profesi === 'Dokter') {
      this.form.dokter_user_id = this.stateuser.id;
      this.form.dokter_obj = { id: this.stateuser.id, nama: this.stateuser.nama };
    }
    this.isEditing = true;
    this.editingId = null;
  }

  startEdit() {
    const d = this.stateData;
    this.form = {
      ...d,
      waktu_kehadiran: d.waktu_kehadiran ? this.toLocalDatetime(new Date(d.waktu_kehadiran)) : null,
      waktu_onset_gejala: d.waktu_onset_gejala ? this.toLocalDatetime(new Date(d.waktu_onset_gejala)) : null,
      dokter_obj: d.dokter ? { id: d.dokter_user_id, nama: d.dokter_nama } : null
    };
    this.editingId = d.id;
    this.isEditing = true;
  }

  cancelForm() {
    this.isEditing = false;
    this.editingId = null;
    this.form = this.getEmptyForm();
  }

  async simpan() {
    const ref = this.$refs.formRef as any;
    if (ref && !ref.validate()) return;

    // Check all booleans answered
    const allBoolKeys = [
      ...this.indikasiItems.map(i => i.key),
      ...this.allKontraKeys
    ];
    for (const k of allBoolKeys) {
      if (this.form[k] === null || this.form[k] === undefined) {
        appModule.NoticeDelay("Semua item bagian A (Indikasi) dan B (Kontra Indikasi) wajib dijawab");
        return;
      }
    }

    this.saving = true;

    // Auto-calc keputusan if not overridden
    const autoKeputusan = this.computedKeputusan;
    const keputusan = this.form.keputusan || autoKeputusan;

    try {
      const pasienRm = this.rm || this.$route?.params?.rm;
      const payload = {
        register_id: this.register,
        pasien_rm: pasienRm,
        waktu_kehadiran: this.form.waktu_kehadiran,
        waktu_onset_gejala: this.form.waktu_onset_gejala,
        window_waktu: this.form.window_waktu,
        a1_informed_consent: this.form.a1_informed_consent,
        a2_waktu_kurang_4_5_jam: this.form.a2_waktu_kurang_4_5_jam,
        a3_stroke_iskemik_nihss: this.form.a3_stroke_iskemik_nihss,
        a4_usia_diatas_18: this.form.a4_usia_diatas_18,
        nihss_score: this.form.nihss_score,
        b1_1_bedah_saraf_3bulan: this.form.b1_1_bedah_saraf_3bulan,
        b1_2_perdarahan_intrakranial: this.form.b1_2_perdarahan_intrakranial,
        b1_3_avm_aneurisma: this.form.b1_3_avm_aneurisma,
        b1_4_perdarahan_gi_urin_21hari: this.form.b1_4_perdarahan_gi_urin_21hari,
        b1_5_operasi_besar_14hari: this.form.b1_5_operasi_besar_14hari,
        b2_1_perbaikan_cepat: this.form.b2_1_perbaikan_cepat,
        b2_2_td_tinggi: this.form.b2_2_td_tinggi,
        b2_3_kejang_onset: this.form.b2_3_kejang_onset,
        b2_4_perdarahan_subarakhnoid: this.form.b2_4_perdarahan_subarakhnoid,
        b2_5_infark_miokard_30hari: this.form.b2_5_infark_miokard_30hari,
        b3_1_antikoagulan_ptt_inr: this.form.b3_1_antikoagulan_ptt_inr,
        b3_2_heparin_aptt: this.form.b3_2_heparin_aptt,
        b3_3_trombosit_rendah: this.form.b3_3_trombosit_rendah,
        b3_4_glukosa_abnormal: this.form.b3_4_glukosa_abnormal,
        b3_5_kehamilan_positif: this.form.b3_5_kehamilan_positif,
        b4_1_lesi_densitas_tinggi: this.form.b4_1_lesi_densitas_tinggi,
        b4_2_efek_massa_midline: this.form.b4_2_efek_massa_midline,
        b4_3_hipodensitas_33persen: this.form.b4_3_hipodensitas_33persen,
        keputusan: keputusan,
        dokter_user_id: this.form.dokter_obj ? this.form.dokter_obj.id : this.form.dokter_user_id
      };

      let resp;
      if (this.editingId) {
        resp = await ScreeningTrombolisisSvc.update(this.editingId, payload);
      } else {
        resp = await ScreeningTrombolisisSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Screening Trombolisis berhasil disimpan");
        this.cancelForm();
        storeScreeningTrombolisis.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  openTtd() {
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const resp = await ScreeningTrombolisisSvc.signDokter(this.stateData.id, { password });

    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay("Berhasil Tanda Tangan Dokter");
      appModule.addMsgTtd("");
      storeScreeningTrombolisis.getByRegister(this.register);
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  cetakPdf() {
    ScreeningTrombolisisSvc.print(this.stateData.id);
  }

  async remove() {
    if (!this.canDelete) return;
    const q = confirm("Anda yakin akan menghapus Screening Trombolisis ini?");
    if (!q) return;

    try {
      const resp = await ScreeningTrombolisisSvc.destroy(this.stateData.id);
      if (resp) {
        appModule.NoticeDelay("Berhasil menghapus data");
        storeScreeningTrombolisis.getByRegister(this.register);
      }
    } catch {
      // handled by service
    }
  }
}
